// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_List from "rescript/lib/es6/belt_List.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as ReactAlert from "react-alert";
import * as SimpleAlert$DvmAdminFrontendFr from "../../../../../../alert/SimpleAlert.bs.js";
import * as Utils_Alert$DvmAdminFrontendFr from "../../../../../../common/utils/Utils_Alert.bs.js";
import * as User_Context$DvmAdminFrontendFr from "../../../../../../context/user/User_Context.bs.js";
import * as App_Types_Result$DvmAdminFrontendFr from "../../../../../../common/types/App_Types_Result.bs.js";
import * as Order_Detail_Bonus_DealerRequest_Create_Api$DvmAdminFrontendFr from "./Order_Detail_Bonus_DealerRequest_Create_Api.bs.js";

function Order_Detail_Bonus_DealerRequest_Document_Uploader(Props) {
  var setUploadPending = Props.setUploadPending;
  var newDocuments = Props.newDocuments;
  var setNewDocuments = Props.setNewDocuments;
  var saveResult = Props.saveResult;
  var orderId = Props.orderId;
  var actionId = Props.actionId;
  var setExistingDocuments = Props.setExistingDocuments;
  var alert = ReactAlert.useAlert();
  var match = Curry._1(User_Context$DvmAdminFrontendFr.Context.useAppContext, undefined);
  var match$1 = match[0];
  var userManager = match$1.userManager;
  var selectedRole = match$1.selectedRole;
  var match$2 = React.useState(function () {
        return /* NotStarted */0;
      });
  var setDocumentSaveResult = match$2[1];
  var documentSaveResult = match$2[0];
  var postFirstInList = function (list) {
    Belt_Option.mapWithDefault(Belt_List.head(list), undefined, (function (file) {
            Order_Detail_Bonus_DealerRequest_Create_Api$DvmAdminFrontendFr.postFile(userManager, file, selectedRole, orderId, actionId, setDocumentSaveResult);
          }));
  };
  React.useEffect((function () {
          if (App_Types_Result$DvmAdminFrontendFr.isSuccess(saveResult)) {
            postFirstInList(newDocuments);
            Curry._1(setUploadPending, (function (param) {
                    return true;
                  }));
          }
          
        }), [saveResult]);
  React.useEffect((function () {
          if (typeof documentSaveResult === "number") {
            documentSaveResult === /* NotStarted */0;
          } else if (documentSaveResult.TAG === /* Ok */0) {
            var tailOfList = Belt_Option.getWithDefault(Belt_List.tail(newDocuments), /* [] */0);
            var headOfList = Belt_List.head(newDocuments);
            postFirstInList(tailOfList);
            Curry._1(setNewDocuments, (function (param) {
                    return tailOfList;
                  }));
            Belt_Option.mapWithDefault(headOfList, undefined, (function (x) {
                    Curry._1(setExistingDocuments, (function (existingDocuments) {
                            return Belt_List.concat(existingDocuments, {
                                        hd: {
                                          orderId: orderId,
                                          actionId: actionId,
                                          fileId: undefined,
                                          fileName: x.document.name,
                                          fileType: x.fileType,
                                          comment: x.comment,
                                          userId: undefined,
                                          importDate: undefined
                                        },
                                        tl: /* [] */0
                                      });
                          }));
                  }));
          } else {
            Utils_Alert$DvmAdminFrontendFr.error(undefined, alert, React.createElement(SimpleAlert$DvmAdminFrontendFr.make, {
                      message: {
                        TAG: /* RestError */2,
                        _0: documentSaveResult._0
                      }
                    }));
            Curry._1(setUploadPending, (function (param) {
                    return false;
                  }));
          }
        }), [documentSaveResult]);
  return null;
}

var Api;

var make = Order_Detail_Bonus_DealerRequest_Document_Uploader;

export {
  Api ,
  make ,
}
/* react Not a pure module */
